import { render, staticRenderFns } from "./StaticFieldsPage.vue?vue&type=template&id=15f61fdc&"
import script from "./StaticFieldsPage.vue?vue&type=script&lang=js&"
export * from "./StaticFieldsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports